module.exports = __webpack_public_path__ + "img/stopper.db30bbcb.svg";